function initFancyBox() {
	var sliderThumbs, sliderImages

	function doubleSliderSwiper() {
		// ! Основной слайдер с миниатюрами
		sliderThumbs = new Swiper('.slider__thumbs--main .swiper-container', {
			// ищем слайдер превью по селектору
			// ? задаем параметры
			direction: 'vertical', // вертикальная прокрутка
			slidesPerView: '3', // показывать по 3 превью
			spaceBetween: 10, // расстояние между слайдами
			navigation: {
				// задаем кнопки навигации
				nextEl: '.slider__next', // кнопка Next
				prevEl: '.slider__prev', // кнопка Prev
			},
			freeMode: true, // при перетаскивании превью ведет себя как при скролле
			breakpoints: {
				// условия для разных размеров окна браузера
				0: {
					// при 0px и выше
					direction: 'horizontal', // горизонтальная прокрутка
				},
				768: {
					// при 768px и выше
					direction: 'vertical', // вертикальная прокрутка
					slidesPerView: 6,
				},
			},
		})
		// ? Инициализация слайдера изображений
		sliderImages = new Swiper('.slider__images--main .swiper-container', {
			// ищем слайдер превью по селектору
			// задаем параметры
			direction: 'vertical', // вертикальная прокрутка
			slidesPerView: 1, // показывать по 1 изображению
			spaceBetween: 10, // расстояние между слайдами
			mousewheel: true, // можно прокручивать изображения колёсиком мыши
			navigation: {
				// задаем кнопки навигации
				nextEl: '.slider__next', // кнопка Next
				prevEl: '.slider__prev', // кнопка Prev
			},
			grabCursor: true, // менять иконку курсора
			thumbs: {
				// указываем на превью слайдер
				swiper: sliderThumbs, // указываем имя превью слайдера
			},
			breakpoints: {
				// условия для разных размеров окна браузера
				0: {
					// при 0px и выше
					direction: 'horizontal', // горизонтальная прокрутка
				},
				768: {
					// при 768px и выше
					direction: 'vertical', // вертикальная прокрутка
				},
			},
		})
		sliderThumbs.on('swipee', function (swipe, event) {
			sliderImages.slideTo(event.v, 0, false)
		})
	}
	doubleSliderSwiper()

	if (document.querySelector('.slider--vertical') !== null) {
		$.extend(true, $.fancybox.defaults, {
			// ! Анимация открытия
			// false - отключить
			// "zoom" - увеличить изображение от / до миниатюры
			// "fade"
			// "zoom-in-out"
			animationEffect: 'zoom-in-out',

			// ! Анимация перехода между слайдами
			//   false            - disable
			//   "fade'
			//   "slide'
			//   "circular'
			//   "tube'
			//   "zoom-in-out'
			//   "rotate'
			transitionEffect: 'circular',

			// ! Анимация перехода между слайдами
			transitionDuration: 500,
			// ! Бесконечное прокручивание слайдов
			loop: true,
			// ! Переключение слайдов прокруткой мышью
			wheel: 'auto',
			// ! Защита слайдов (отключает правый щелчок мыши, чтобы не было возможности просмотреть код)
			protect: false,
			// ! Переключение с помощью клавиатуры
			keyboard: true,
			// ! Отключение/ включение стрелок переключения слайдов
			arrows: true,
			// ! Отключение/ включение Инфобара (это где пишется количество слайдов)
			infobar: true,
			// ! Отключение/ включение Тулбара (это где выбор элементов (лупа, скачать картинку и тд))
			toolbar: true,

			// ? Выбор активных кнопок в Тулбаре

			buttons: ['zoom', 'share', 'slideShow', 'fullScreen', 'download', 'thumbs', 'close'],

			// ? Русификатор кнопок (при наведение на них доп информация)

			lang: 'ru',
			i18n: {
				ru: {
					CLOSE: 'Закрыть',
					NEXT: 'Вперед',
					PREV: 'Назад',
					ERROR: 'Запрашиваемый контент не может быть загружен. <br/> Пожалуйста, попробуйте позже.',
					PLAY_START: 'Начать демонстрацию',
					PLAY_STOP: 'Приостановить демонстрацию',
					FULL_SCREEN: 'На полный экран',
					THUMBS: 'Миниатюры',
					DOWNLOAD: 'Скачать',
					SHARE: 'Поделиться',
					ZOOM: 'Увеличить',
				},
			},
			afterClose: function (close, event) {
				sliderThumbs.emit('swipee', { v: event.index })
			},
		})
	} else {
		$.extend(true, $.fancybox.defaults, {
			// ! Анимация открытия
			// false - отключить
			// "zoom" - увеличить изображение от / до миниатюры
			// "fade"
			// "zoom-in-out"
			animationEffect: 'zoom-in-out',

			// ! Анимация перехода между слайдами
			//   false            - disable
			//   "fade'
			//   "slide'
			//   "circular'
			//   "tube'
			//   "zoom-in-out'
			//   "rotate'
			transitionEffect: 'circular',

			// ! Анимация перехода между слайдами
			transitionDuration: 500,
			// ! Бесконечное прокручивание слайдов
			loop: true,
			// ! Переключение слайдов прокруткой мышью
			wheel: 'auto',
			// ! Защита слайдов (отключает правый щелчок мыши, чтобы не было возможности просмотреть код)
			protect: false,
			// ! Переключение с помощью клавиатуры
			keyboard: true,
			// ! Отключение/ включение стрелок переключения слайдов
			arrows: true,
			// ! Отключение/ включение Инфобара (это где пишется количество слайдов)
			infobar: true,
			// ! Отключение/ включение Тулбара (это где выбор элементов (лупа, скачать картинку и тд))
			toolbar: true,

			// ? Выбор активных кнопок в Тулбаре

			buttons: ['zoom', 'share', 'slideShow', 'fullScreen', 'download', 'thumbs', 'close'],

			// ? Русификатор кнопок (при наведение на них доп информация)

			lang: 'ru',
			i18n: {
				ru: {
					CLOSE: 'Закрыть',
					NEXT: 'Вперед',
					PREV: 'Назад',
					ERROR: 'Запрашиваемый контент не может быть загружен. <br/> Пожалуйста, попробуйте позже.',
					PLAY_START: 'Начать демонстрацию',
					PLAY_STOP: 'Приостановить демонстрацию',
					FULL_SCREEN: 'На полный экран',
					THUMBS: 'Миниатюры',
					DOWNLOAD: 'Скачать',
					SHARE: 'Поделиться',
					ZOOM: 'Увеличить',
				},
			},
		})
	}

	$('[data-fancybox-window]').fancybox({
		closeExisting: false,
		infobar: false,
		touch: false,
		toolbar: false,
		// modal: false,
		// hideOnOverlayClick: true,
		// enableEscapeButton: true,
		// clickOutside: true,
		// closeExisting: false,
	})
}
